import type { ItemStatus } from "@/lib/types";

type SellerPriceDecisionStatus = Extract<
  ItemStatus,
  "needs_user_action" | "resubmitted"
>;

type SellerPriceDecisionWizardStatus = Extract<
  ItemStatus,
  "needs_user_action" | "rejected" | "resubmitted"
>;

/** Statuses where seller price accept / reject / counter UI may apply. */
export const SELLER_PRICE_DECISION_STATUSES: ReadonlySet<SellerPriceDecisionStatus> =
  new Set(["needs_user_action", "resubmitted"]);

/**
 * Statuses where the fix→price edit wizard may run (includes rejected).
 * Superset of {@link SELLER_PRICE_DECISION_STATUSES}.
 */
export const SELLER_PRICE_DECISION_WIZARD_STATUSES: ReadonlySet<SellerPriceDecisionWizardStatus> =
  new Set(["needs_user_action", "rejected", "resubmitted"]);

export function isSellerPriceDecisionStatus(
  status: string | null | undefined,
): status is SellerPriceDecisionStatus {
  return Boolean(
    status &&
      SELLER_PRICE_DECISION_STATUSES.has(status as SellerPriceDecisionStatus),
  );
}

export function isSellerPriceDecisionWizardStatus(
  status: string | null | undefined,
): status is SellerPriceDecisionWizardStatus {
  return Boolean(
    status &&
      SELLER_PRICE_DECISION_WIZARD_STATUSES.has(
        status as SellerPriceDecisionWizardStatus,
      ),
  );
}
